'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var _formValidation = require('helpers/formValidation');

var _formValidation2 = _interopRequireDefault(_formValidation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = (0, _validation.createValidator)({
  subject: _formValidation2.default.field,
  message: _formValidation2.default.field
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/quickSendFormValidation.js
// module id = 843
// module chunks = 1